import { render, staticRenderFns } from "./AlarmList.vue?vue&type=template&id=33f567a8"
import script from "./AlarmList.vue?vue&type=script&lang=js"
export * from "./AlarmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports